var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyrightImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1838_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38Z",
    fill: "#F4DD01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7306 28.2541H13.0229V9.6582H15.9439V25.3319H20.7255L20.7306 28.2541Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9878 26.8476C24.9901 27.1936 24.8723 27.5297 24.6544 27.7986C24.4365 28.0674 24.1321 28.2523 23.7931 28.3217C23.4541 28.3912 23.1015 28.3408 22.7955 28.1793C22.4895 28.0178 22.249 27.7551 22.115 27.436C21.9811 27.1169 21.962 26.7613 22.0611 26.4297C22.1601 26.0981 22.3711 25.8112 22.6581 25.6179C22.9451 25.4245 23.2902 25.3367 23.6347 25.3695C23.9792 25.4023 24.3016 25.5535 24.547 25.7975C24.6883 25.9332 24.8003 26.0963 24.8762 26.2769C24.952 26.4575 24.99 26.6517 24.9878 26.8476Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1838_760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyrightImg);
export default __webpack_public_path__ + "static/media/copyright_img.1655b12d9708a366fe60762affb85c75.svg";
export { ForwardRef as ReactComponent };